const ASCII_OFFSET = 97;
const ALPHA_COUNT = 26;
/**
 * Get the letter associated with a waypoint index
 * Ex: 0 -> A, 1 -> B, 26 -> AA, 27 -> AB
 */

const getWaypointLetter = waypointIndex => {
  const conversionNumber = waypointIndex;

  const numToChar = num => String.fromCharCode(num + ASCII_OFFSET);

  const loopCount = Math.floor(conversionNumber / ALPHA_COUNT);
  const mod = conversionNumber % ALPHA_COUNT;

  if (loopCount) {
    return `${numToChar(loopCount - 1)}${numToChar(mod)}`.toUpperCase();
  }

  return `${numToChar(mod)}`.toUpperCase();
};

export { getWaypointLetter };
